import React, { useState, useEffect } from "react";
import CardPost from "./CardPost";
import style from "./post.module.css";
import axios from "axios";
import Loading from "../../../UI/Loading";

const Post = () => {
  const [posts, setPosts] = useState({ data: [], lastPage: 1 });
  const [loading, setLoading] = useState(false);
  const [counter, setCounter] = useState(1);
  const fetchData = async () => {
    setLoading(true);
    await axios
      .get(`${process.env.REACT_APP_LINK_API}post?page=${counter}`)
      .then((res) => {
        const dataPost = res.data.data;
        setPosts({
          data: dataPost.data,
          totalData: dataPost.totalData,
          currentPage: dataPost.current_page,
          lastPage: dataPost.last_page,
        });
      })
      .catch((error) => {
        console.log(error.response.data);
      });
    setLoading(false);
  };
  const paginationItems = [];

  for (let i = 1; i <= posts.lastPage; i++) {
    paginationItems.push(
      <li className={`page-item ${counter === i ? "active" : ""}`} key={i}>
        <a className="page-link" href="#post" onClick={() => setCounter(i)}>
          {i}
        </a>
      </li>
    );
  }

  useEffect(() => {
    fetchData();
  }, [counter]);

  if (loading) {
    return <Loading load={loading} />;
  }

  return (
    <div className={`${"post"} ${style.post}`} id="post">
      <div className={style.title}>
        <h1>Post</h1>
      </div>
      <div className={`container-fluid ${style.container_card}`}>
        <div className="row">
          {posts.data.map((post) => (
            <div className="col-md-4" key={post.id}>
              <CardPost post={post} />
            </div>
          ))}

          <nav aria-label="Page navigation example">
            <ul className="pagination justify-content-center">
              <li className={`page-item ${counter <= 1 ? "disabled" : ""}`}>
                <a
                  className="page-link"
                  href="#post"
                  onClick={() => {
                    setCounter(counter <= 1 ? 1 : counter - 1);
                  }}
                >
                  Previous
                </a>
              </li>
              {paginationItems}
              <li
                className={`page-item ${
                  counter >= posts.lastPage ? "disabled" : ""
                }`}
              >
                <a
                  className="page-link"
                  href="#post"
                  onClick={() => {
                    setCounter(
                      counter >= posts.lastPage ? posts.lastPage : counter + 1
                    );
                  }}
                >
                  Next
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Post;
